export default __webpack_public_path__ + "static/media/DGX-B200.9b61e42d.png";